var _linearGradient, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    x2: 512,
    y1: 256,
    y2: 256
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#80d8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ea80fc"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 96v-76c0-11.046875 8.953125-20 20-20h76c11.046875 0 20 8.953125 20 20s-8.953125 20-20 20h-56v56c0 11.046875-8.953125 20-20 20s-20-8.953125-20-20zm492-96h-76c-11.046875 0-20 8.953125-20 20s8.953125 20 20 20h56v56c0 11.046875 8.953125 20 20 20s20-8.953125 20-20v-76c0-11.046875-8.953125-20-20-20zm-396 472h-56v-56c0-11.046875-8.953125-20-20-20s-20 8.953125-20 20v76c0 11.046875 8.953125 20 20 20h76c11.046875 0 20-8.953125 20-20s-8.953125-20-20-20zm396-76c-11.046875 0-20 8.953125-20 20v56h-56c-11.046875 0-20 8.953125-20 20s8.953125 20 20 20h76c11.046875 0 20-8.953125 20-20v-76c0-11.046875-8.953125-20-20-20zm-253.5-297.5v120c0 11.046875-8.953125 20-20 20h-120c-11.046875 0-20-8.953125-20-20v-120c0-11.046875 8.953125-20 20-20h120c11.046875 0 20 8.953125 20 20zm-40 20h-80v80h80zm225 120h-120c-11.046875 0-20-8.953125-20-20v-120c0-11.046875 8.953125-20 20-20h120c11.046875 0 20 8.953125 20 20v120c0 11.046875-8.953125 20-20 20zm-20-120h-80v80h80zm-165 185v120c0 11.046875-8.953125 20-20 20h-120c-11.046875 0-20-8.953125-20-20v-120c0-11.046875 8.953125-20 20-20h120c11.046875 0 20 8.953125 20 20zm-40 20h-80v80h80zm199.25 94.25h-68.5c-11.046875 0-20-8.953125-20-20v-68.5c0-11.046875 8.953125-20 20-20h68.5c11.046875 0 20 8.953125 20 20v68.5c0 11.046875-8.953125 20-20 20zm-20-68.5h-28.5v28.5h28.5zm0 0",
    fill: "url(#a)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qr-code.7fbbc732c1866ce2bd4eba7434fcb047.svg";
export { ForwardRef as ReactComponent };